import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../../context/LanguageContext";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import {
  StyledCard,
  StyledCardBody,
  StyledCardHeader,
} from "../../../../styles/CardStyles";
import {
  StyledFlexColumn,
  StyledFlexRow,
} from "../../../../styles/LayoutStyles";
import IconSelect from "../../../../components/select/main/icon/IconSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import Select from "../../../../components/select/main/Select";
import { StyledAltIconButton } from "../../../../styles/ButtonStyles";

function SaltoVisitorTypesView({
  availableVisitorTypes = [],
  onVisitorTypeAdd,
  visitorTypeLabels = {},
  configData,
  saltoResources,
  onAccessGroupChange,
  onRoleChange,
  onVisitorTypeDelete,
}) {
  const theme = useTheme();
  const { translate, translateEntity } = useLanguageContext();

  return (
    <OverlayLoader groups="salto_configs_page_fetch">
      <StyledCard>
        <StyledCardHeader>
          <StyledFlexRow
            style={{
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 style={{ flex: 1 }}>
              {translate("eva.main.entities.visitor_types")}
            </h2>

            <IconSelect
              options={availableVisitorTypes.map((visitorType) => ({
                value: visitorType.id,
                label: translateEntity(visitorType, "label"),
              }))}
              icon={() => <FontAwesomeIcon icon={faPlus} />}
              style={{ marginLeft: "auto" }}
              onChange={(value) => onVisitorTypeAdd(value)}
              disabled={availableVisitorTypes.length <= 0}
            />
          </StyledFlexRow>
        </StyledCardHeader>

        <StyledCardBody>
          <StyledFlexColumn>
            {configData?.visitor_types?.map((configVisitorType) => (
              <StyledFlexRow
                key={configVisitorType.visitor_type_id}
                style={{
                  alignItems: "flex-end",
                  padding: theme.spacing.normal,
                  borderRadius: theme.radius.normal,
                  border: `1px solid ${theme.colors.primary.darkest}`,
                }}
              >
                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.visitor_types.*.visitor_type_id",
                  )}
                  required
                  style={{ flex: 1 }}
                >
                  <Select
                    value={configVisitorType.visitor_type_id}
                    options={[
                      {
                        value: configVisitorType.visitor_type_id,
                        label:
                          visitorTypeLabels[configVisitorType.visitor_type_id],
                      },
                    ]}
                    style={{ opacity: 1 }}
                    hideCaret={true}
                    disabled
                  />
                </InputWrapper>

                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.visitor_types.*.access_group_id",
                  )}
                  required
                  style={{ flex: 1 }}
                >
                  <Select
                    value={configVisitorType.access_group_id}
                    options={saltoResources.access_groups.map(
                      (accessGroup) => ({
                        value: accessGroup.id,
                        label: accessGroup.label,
                      }),
                    )}
                    onChange={(value) =>
                      onAccessGroupChange(
                        configVisitorType.visitor_type_id,
                        value,
                      )
                    }
                  />
                </InputWrapper>

                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.visitor_types.*.role_id",
                  )}
                  required
                  style={{ flex: 1 }}
                >
                  <Select
                    value={configVisitorType.role_id}
                    options={saltoResources.roles?.map((role) => ({
                      value: role.id,
                      label: `${role.label} (${
                        saltoResources.sites.find(
                          (site) => site.id === role.site_id,
                        )?.label
                      })`,
                    }))}
                    onChange={(value) =>
                      onRoleChange(configVisitorType.visitor_type_id, value)
                    }
                  />
                </InputWrapper>

                <StyledAltIconButton
                  onClick={() =>
                    onVisitorTypeDelete(configVisitorType.visitor_type_id)
                  }
                >
                  <FontAwesomeIcon icon={faTrash} />
                </StyledAltIconButton>
              </StyledFlexRow>
            ))}
          </StyledFlexColumn>
        </StyledCardBody>
      </StyledCard>
    </OverlayLoader>
  );
}

export default SaltoVisitorTypesView;
